var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Button, ControlLabel } from 'react-bootstrap';
import React, { Component } from 'react';
import FormBuilder from '../FormBuilder';
import PropTypes from 'prop-types';

import './BlockButton.css';

function AddRemove(_ref) {
  var bsStyle = _ref.bsStyle,
      label = _ref.label,
      onClick = _ref.onClick;

  return React.createElement(
    'div',
    { className: 'BlockButton' },
    React.createElement(
      Button,
      {
        block: true,
        bsStyle: bsStyle,
        onClick: onClick },
      label
    )
  );
}

var ExpandableForm = function (_Component) {
  _inherits(ExpandableForm, _Component);

  function ExpandableForm() {
    var _temp, _this, _ret;

    _classCallCheck(this, ExpandableForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      rows: _this.props.rows || 1
    }, _this.rows = function () {
      if (_this.props.name) {
        var r = _this.context.form.get(_this.props.name);
        if (r) {
          return r;
        }
      }
      return _this.state.rows;
    }, _this.setRows = function (value) {
      if (_this.props.name) {
        _this.context.form.set(_this.props.name, Number(value));
        return;
      }
      _this.setState({ rows: Number(value) });
    }, _this.handleAdd = function () {
      _this.setRows(_this.rows() + 1);
    }, _this.handleRemove = function () {
      var suffix = '_' + (_this.rows() - 1);
      for (var _iterator = _this.props.template, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref2 = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref2 = _i.value;
        }

        var item = _ref2;

        _this.context.form.set(item.name + suffix, '');
      }
      _this.setRows(_this.rows() - 1);
    }, _this.renderRow = function (i) {
      return _this.props.template.map(function (item) {
        return _extends({}, item, {
          label: item.label ? item.label + ' ' + (i + 1) : '',
          name: item.name + '_' + i
        });
      });
    }, _this.renderButtons = function () {
      var row = [{
        bsStyle: 'success',
        label: 'Add Row',
        onClick: _this.handleAdd,
        type: 'expandable-editor'
      }];

      if (_this.rows() > 1) {
        row.push({
          bsStyle: 'danger',
          label: 'Remove Row',
          onClick: _this.handleRemove,
          type: 'expandable-editor'
        });
      }

      return row;
    }, _this.customFields = function () {
      return _extends({}, _this.context.customFields || {}, {
        'expandable-editor': AddRemove
      });
    }, _this.form = function () {
      var form = [];
      for (var i = 0; i < _this.rows(); i++) {
        form.push(_this.renderRow(i));
      }
      form.push(_this.renderButtons());
      return form;
    }, _this.render = function () {
      return React.createElement(
        'div',
        null,
        _this.props.label && React.createElement(
          ControlLabel,
          null,
          _this.props.label
        ),
        React.createElement(FormBuilder, {
          customFields: _this.customFields(),
          form: _this.form(),
          store: _this.context.form
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ExpandableForm;
}(Component);

AddRemove.propTypes = process.env.NODE_ENV !== "production" ? {
  bsStyle: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
} : {};

ExpandableForm.contextTypes = {
  customFields: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};

ExpandableForm.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  name: PropTypes.string,
  rows: PropTypes.number,
  template: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  })).isRequired
} : {};

export default ExpandableForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/ExpandableForm.js
// module id = 698
// module chunks = 0